import { ProductType } from '@shared/utils/Instruments/ProductType';
import { NO_BIND_TO } from '@shared/utils/Trading/OrderConstants';
import { OrderExecutionType } from '@shared/utils/Trading/OrderExecutionType';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderType } from '@shared/utils/Trading/OrderType';
// TODO. Inherit from DataCacheBusinessObject.
export class OrderHistory {
    constructor() {
        this.ProductType = ProductType.General;
        this.FRemainingQuantity = 0;
        this.FFilledQuantity = 0;
        this.FPutCall = 0;
        this.FExternalOrderId = null;
        this.FExternalTradeId = null;
        this.FExpYear = 0;
        this.FExpMonth = 0;
        this.FExpDay = 0;
        this.FStrikePrice = 0;
        this.id = '';
        this.InstrumentStr = null;
        this.AccountStr = null;
        this.FBuySell = 0;
        this.FDate = null;
        // Raw value ExecutionType.
        this.eventTypeRaw = OrderExecutionType.UNKNOWN;
        this.FMessage = '';
        this.FOrderNumber = '';
        this.FOrderType = undefined;
        this.FPrice = 0;
        this.FQuantity = 0;
        this.FDisclosedQty = 0;
        this.FRoute = '';
        this.FRemoteId = '';
        this.FStopLimit = 0;
        this.FTime = null;
        this.FUTCDateTime = null;
        this.FTimeInForce = null;
        this.FTraderId = '';
        this.boundToOrderId = '-1';
        this.FPositionId = '-1';
        this.Description = null;
        this.boughtString = '';
        this.soldString = '';
        this.TradingExchange = '';
        this.FLeverage = null;
        this.FAccount = null;
        this.FInstrument = null;
    }
    get Instrument() {
        return this.FInstrument;
    }
    set Instrument(value) {
        this.FInstrument = value;
        this.InstrumentStr = value ? value.DisplayName() : null;
    }
    get Account() {
        return this.FAccount;
    }
    set Account(value) {
        this.FAccount = value;
        this.AccountStr = value ? this.FAccount.toString() : null;
    }
    get Id() {
        return this.id;
    }
    // get Alive (): boolean { return this.FEvent === 'Live'; }
    get BuySell() {
        return this.FBuySell;
    }
    set BuySell(value) {
        this.FBuySell = value;
    }
    get Date() {
        return this.FDate;
    }
    set Date(value) {
        this.FDate = value;
    }
    get Message() {
        return this.FMessage;
    }
    set Message(value) {
        this.FMessage = value;
    }
    get OrderNumber() {
        return this.FOrderNumber;
    }
    set OrderNumber(value) {
        this.FOrderNumber = value;
    }
    get OrderType() {
        return this.FOrderType;
    }
    set OrderType(value) {
        this.FOrderType = value;
    }
    get Price() {
        return this.FPrice;
    }
    set Price(value) {
        this.FPrice = value;
    }
    get Quantity() {
        return this.FQuantity;
    }
    set Quantity(value) {
        this.FQuantity = value;
    }
    get DisclosedQty() {
        return this.FDisclosedQty;
    }
    set DisclosedQty(value) {
        this.FDisclosedQty = value;
    }
    get Route() {
        return this.FRoute;
    }
    set Route(value) {
        this.FRoute = value;
    }
    get RemoteId() {
        return this.FRemoteId;
    }
    set RemoteId(value) {
        this.FRemoteId = value;
    }
    get StopLimit() {
        return this.FStopLimit;
    }
    set StopLimit(value) {
        this.FStopLimit = value;
    }
    get Time() {
        return this.FTime;
    }
    set Time(value) {
        this.FTime = value;
    }
    get UTCDateTime() {
        return this.FUTCDateTime;
    }
    set UTCDateTime(value) {
        this.FUTCDateTime = value;
    }
    get TimeInForce() {
        return this.FTimeInForce;
    }
    set TimeInForce(value) {
        this.FTimeInForce = value;
    }
    get TraderId() {
        return this.FTraderId;
    }
    set TraderId(value) {
        this.FTraderId = value;
    }
    get BoundToOrderId() {
        return this.boundToOrderId;
    }
    set BoundToOrderId(value) {
        this.boundToOrderId = value;
    }
    get PositionId() {
        return this.FPositionId;
    }
    set PositionId(value) {
        this.FPositionId = value;
    }
    get ExpYear() {
        const ins = this.Instrument;
        const date = ins ? ins.ExpDateReal : null;
        const year = date ? date.getUTCFullYear() : 0;
        return year > 2000 ? year : this.FExpYear;
    }
    set ExpYear(value) {
        this.FExpYear = value;
    }
    get ExpMonth() {
        const ins = this.Instrument;
        const date = ins ? ins.ExpDateReal : null;
        const month = date ? date.getUTCMonth() : 0;
        return month > 0 ? month : this.FExpMonth;
    }
    set ExpMonth(value) {
        this.FExpMonth = value;
    }
    get ExpDay() {
        const ins = this.Instrument;
        const date = ins ? ins.ExpDateReal : null;
        const day = date ? date.getUTCDate() : 0;
        return day > 0 ? day : this.FExpDay;
    }
    set ExpDay(value) {
        this.FExpDay = value;
    }
    get StrikePrice() {
        const ins = this.Instrument;
        return ins && ins.StrikePrice > 0 ? ins.StrikePrice : this.FStrikePrice;
    }
    set StrikePrice(value) {
        this.FStrikePrice = value;
    }
    get PutCall() {
        const ins = this.Instrument;
        return ins && ins.PutCall > -1 ? ins.PutCall : this.FPutCall;
    }
    set PutCall(value) {
        this.FPutCall = value;
    }
    get ExternalOrderId() {
        return this.FExternalOrderId;
    }
    set ExternalOrderId(value) {
        this.FExternalOrderId = value;
    }
    get ExternalTradeId() {
        return this.FExternalTradeId;
    }
    set ExternalTradeId(value) {
        this.FExternalTradeId = value;
    }
    get FilledQuantity() {
        return this.FFilledQuantity;
    }
    set FilledQuantity(value) {
        this.FFilledQuantity = value;
    }
    get RemainingQuantity() {
        return this.FRemainingQuantity;
    }
    set RemainingQuantity(value) {
        this.FRemainingQuantity = value;
    }
    get Leverage() {
        return this.FLeverage;
    }
    set Leverage(value) {
        this.FLeverage = value;
    }
    static fromMessage(message, dc) {
        var _a;
        // const res = new OrderHistory(dc);
        // if (!dc) {
        //     return res;
        // } Для цього немає поки логіки
        const res = new OrderHistory();
        res.id = (OrderHistory.OrderHistoryID++).toString();
        res.Account = dc.GetAccountById(message.Account);
        res.Instrument = dc.getInstrumentByTradable_ID(message.InstrumentTradableID, message.Route);
        if (res.Instrument) {
            res.Description = res.Instrument.DescriptionValue();
        }
        if (!res.Instrument) {
            res.InstrumentStr = message.Symbol;
        }
        res.FBuySell = message.BuySell;
        res.FDate = message.UTCDateTime;
        res.eventTypeRaw = message.EventType;
        res.FOrderNumber = message.OrderNumber;
        res.FOrderType = message.OrderType;
        // binding sl and tp currently occurs by positionId
        res.BoundToOrderId = message.BoundToOrderId;
        const positionId = (res.FPositionId = message.PositionId);
        if (!message.Active && positionId !== NO_BIND_TO) {
            if (message.OrderType === OrderType.Stop) {
                res.FOrderType = OrderType.SLTPStop;
            }
            else if (message.OrderType === OrderType.Limit) {
                res.FOrderType = OrderType.SLTPLimit;
            }
        }
        res.FPrice = message.Price;
        res.FQuantity = message.Quantity;
        res.FRoute = message.Route;
        res.FRemoteId = message.RemoteId;
        res.FStopLimit = message.StopLimit;
        res.FTime = message.UTCDateTime;
        res.FUTCDateTime = message.UTCDateTime;
        const expTimeTicks = ((_a = message.ExpireTime) === null || _a === void 0 ? void 0 : _a.getTime()) || 0;
        res.FTimeInForce = new TIF(message.TimeInForce, expTimeTicks ? message.ExpireTime : null);
        res.FTraderId = message.OrderCreatedByUser;
        // nicky: не показываем пустую дату, если она не ставится вендором,
        // пусть будет как раньше - дата ордера
        const lastUpdateTime = message.LastUpdateTime;
        if (res.Date === null && (lastUpdateTime === null || lastUpdateTime === void 0 ? void 0 : lastUpdateTime.getTime()) > 0) {
            res.FDate = lastUpdateTime;
            res.FTime = lastUpdateTime;
            res.FUTCDateTime = lastUpdateTime;
        }
        res.DisclosedQty = message.DisClosedQuantity;
        res.FilledQuantity = message.FilledQuantity;
        res.RemainingQuantity = message.RemainingQuantity;
        res.ProductType = message.ProductType;
        res.ExternalOrderId = message.ExternalOrderId;
        res.ExternalTradeId = message.ExternalTradeId;
        res.Leverage = message.Leverage;
        return res;
    }
    getAmount() {
        return this.Quantity;
    }
    get Daily() {
        const today = new Date();
        const historyDate = this.Date;
        return (historyDate.getUTCDate() === today.getUTCDate() &&
            historyDate.getUTCMonth() === today.getUTCMonth() &&
            historyDate.getUTCFullYear() === today.getUTCFullYear());
    }
}
// TODO. Ugly as fck.
OrderHistory.OrderHistoryID = 100;
